import type { IconProps } from './IconProps';

export const MatchaGreenInvertedIcon = (props: IconProps) => (
  <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_di_31_20860)">
      <rect x="2" y="2" width="28" height="28" rx="14" fill="url(#paint0_linear_31_20860)" />
      <g filter="url(#filter1_i_31_20860)">
        <path
          d="M19.814 9.85648C19.7837 9.91714 19.711 9.94305 19.6491 9.91525C18.7284 9.49631 17.6093 9.35476 16.8737 9.35476C14.2291 9.35476 11.5839 10.6444 11.5839 12.7644C11.5839 13.9012 12.4364 14.8629 13.6825 14.8629C15.0595 14.8629 16.087 13.8576 16.9173 12.9395C17.6605 12.1092 18.535 11.191 19.7805 11.191C21.136 11.191 22.1193 12.1964 22.1193 13.5518C22.1193 15.6939 19.5398 18.0982 15.977 18.0982C12.4143 18.0982 9.83538 16.1962 9.83538 13.5518C9.83538 11.0817 12.7643 8.85241 15.9776 8.85241C17.6175 8.85241 18.8523 9.19616 19.761 9.68903C19.821 9.72189 19.8444 9.79582 19.814 9.85711V9.85648ZM15.9776 8C11.5839 8 7.99902 11.5847 7.99902 15.9782C7.99902 20.3717 11.5839 24 15.9776 24C20.3714 24 23.9999 20.4153 23.9999 15.9782C23.9999 11.5411 20.4144 8 15.9776 8Z"
          fill="url(#paint1_linear_31_20860)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_31_20860"
        x="0.0445591"
        y="0.696373"
        width="31.9109"
        height="31.9109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.651814" />
        <feGaussianBlur stdDeviation="0.97772" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_20860" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31_20860"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.651814" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_31_20860" />
      </filter>
      <filter
        id="filter1_i_31_20860"
        x="7.99902"
        y="8"
        width="16.001"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_20860" />
      </filter>
      <linearGradient
        id="paint0_linear_31_20860"
        x1="16"
        y1="2"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2CB051" />
        <stop offset="0.773607" stopColor="#59B56D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_31_20860"
        x1="24.1833"
        y1="5.4763"
        x2="14.0179"
        y2="25.3396"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
